import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
} from '@chakra-ui/react';
import LeadSpamPanel from './LeadSpamPanel';

export default function LeadSpamModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="90vh">
        <ModalHeader fontSize="16px">🚫 Lead Spam</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <LeadSpamPanel />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
